// TODO(cruise-demo): Remove this whole module once requirement-level
// threshold summaries have a general design. Every value here is read
// from the project's own requirements + pledges — no hard-coded
// numbers — so the Traveler headline stays truthful as the seed
// changes. Both `pages/ProjectDetail.jsx` and `components/ProjectCard.jsx`
// import from here to guarantee the two surfaces cannot drift.

import { pledgedForReq } from "./domain";

export const CRUISE_ID = "rent-cruise-ship-with-3000-friends";

export const isCruiseShipProject = (project) =>
  !!project && project.id === CRUISE_ID;

// The Traveler requirement (r1) — the *defining* participation
// threshold for this one demo project. Returns null if for any reason
// the requirement is missing.
export function cruiseTravelerHeadline(project, pledges) {
  const r1 = project.requirements.find((r) => r.id === `${CRUISE_ID}-r1`);
  if (!r1) return null;
  const filled = Math.min(r1.needed, pledgedForReq(r1.id, pledges));
  return { requirement: r1, filled, needed: r1.needed };
}

// All requirements except Traveler, in seed order. Used by both
// surfaces to enumerate the five supporting requirements.
export function cruiseSupportingRequirements(project) {
  const skipId = `${CRUISE_ID}-r1`;
  return project.requirements.filter((r) => r.id !== skipId);
}

// Deadpan casing rule that matches the approved prompt examples:
//   • single-word labels preserve casing ("DJs")
//   • proper-noun-led labels preserve casing ("Dramamine travel vials")
//   • other multi-word labels lowercase the first character
//     ("Someone who…" → "someone who…", "Captain's hat" → "captain's hat")
// The proper-noun allowlist is tiny on purpose — this is demo-scoped
// (TODO(cruise-demo)) and the alternative heuristics fight the seed.
const CRUISE_PROPER_NOUN_LEADS = new Set(["Dramamine"]);

function deadpanCase(label) {
  if (!label) return label;
  const firstWord = label.split(" ")[0];
  if (CRUISE_PROPER_NOUN_LEADS.has(firstWord)) return label;
  if (label.includes(" ")) return label.charAt(0).toLowerCase() + label.slice(1);
  return label;
}

const fmtNum = (n) => n.toLocaleString("en-US");

// "1 someone who knows how to rent a cruise ship", "48 DJs",
// "9,372 Dramamine travel vials".
export function cruiseGapPhrase(req, gap) {
  const raw = gap === 1 ? req.label : (req.pluralLabel || `${req.label}s`);
  return `${fmtNum(gap)} ${deadpanCase(raw)}`;
}

// The compact still-need phrases for every supporting requirement that
// currently has a gap > 0, in seed order. Returns [] when all
// supporting requirements are covered.
export function cruiseSupportingGaps(project, pledges) {
  return cruiseSupportingRequirements(project)
    .map((r) => ({ req: r, gap: Math.max(0, r.needed - pledgedForReq(r.id, pledges)) }))
    .filter((x) => x.gap > 0)
    .map(({ req, gap }) => cruiseGapPhrase(req, gap));
}
